import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const MainPageThunk = createAsyncThunk(
	"MainPage/MainPageThunk",
	async (_, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;
		try {
			const url = `https://api.raj.com.sa/api/public/main_pages`;

			const res = await axios.get(url, {
				headers: {
					Locale: localStorage.getItem("language") || navigator?.languages?.[1],
				},
			});

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data);
		}
	}
);
